import { ChangeEvent } from 'react';
import { AuthActionTypes } from '@bridebook/web/lib/auth/action-types';
import {
  AuthBridebookError,
  AuthProviders,
  FirebaseErrorCodes,
  IAuthFields,
} from '@bridebook/web/lib/auth/types';
import mapFBErrorToValidationError from '@bridebook/web/lib/auth/utils/map-fb-error-to-validation-error';
import { toggleSnackbar } from '@bridebook/web/lib/bbcommon/actions';
import { getI18n } from '@bridebook/web/lib/i18n/getI18n';
import { IDeps } from '@bridebook/web/lib/types';
import { settingsToggleChangeEmailForm } from '@bridebook/web/lib/ui/actions';
import { saveUserProvider } from '@bridebook/web/lib/users/actions';

export const changeAuthEmailForm = (e: ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value;
  const name = e.target.name;

  return {
    type: AuthActionTypes.SET_AUTH_EMAIL_FORM_FIELD,
    payload: { name, value },
  };
};

export const changeAuthEmail = (fields: IAuthFields, oldEmail: string) => ({
  type: AuthActionTypes.CHANGE_AUTH_EMAIL,
  payload: { fields, oldEmail },
});

export const changeAuthEmailSuccess =
  (fields: IAuthFields) =>
  ({ dispatch, getState }: IDeps) => {
    const { user } = getState().users;
    dispatch(
      saveUserProvider({
        providerId: AuthProviders.PASSWORD,
        email: fields.email,
        displayName: null,
        phoneNumber: null,
        photoURL: null,
        uid: user ? user.id : '',
      }),
    );
    dispatch(settingsToggleChangeEmailForm(false));
    dispatch(toggleSnackbar('success', getI18n().t('settings:snackbar.emailLoginChanged')));

    dispatch({
      type: 'USER_UPDATED_AUTH_DETAILS_SUCCESS_ANALYTICS',
      payload: { provider: AuthProviders.PASSWORD, fields },
    });

    return {
      type: AuthActionTypes.CHANGE_AUTH_EMAIL_SUCCESS,
    };
  };

export const changeAuthEmailError =
  (fields: IAuthFields, error: AuthBridebookError) =>
  ({ dispatch }: IDeps) => {
    const throwError = error.code
      ? mapFBErrorToValidationError(error.code as FirebaseErrorCodes)
      : error;

    error.provider = AuthProviders.PASSWORD;
    dispatch(toggleSnackbar('alert', error.message));
    dispatch({
      type: 'USER_UPDATED_AUTH_DETAILS_ERROR_ANALYTICS',
      payload: { provider: AuthProviders.PASSWORD, fields, error: throwError },
    });

    return {
      type: AuthActionTypes.CHANGE_AUTH_EMAIL_ERROR,
      payload: throwError,
    };
  };
